import { PaneHeader } from '@/components/settings/pane-header';
import { ThreadGroupsEditor } from '@/components/settings/thread-groups-editor';
import { ScrollArea } from '@/components/ui/scroll-area';

// Thin wrapper that hosts the existing Thread Groups editor inside the settings sub-rail.
// The editor self-loads from its own store; canEdit is the tenant-wide shared-settings gate.
export function ThreadGroupsSubPage({ canEditShared }) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PaneHeader
        title="Thread groups"
        description="Define the groups available in the threads list. Shared with your whole team."
      />
      <ScrollArea className="min-h-0 flex-1" viewportClassName="p-6">
        <div className="mx-auto max-w-3xl">
          <ThreadGroupsEditor canEdit={canEditShared} />
        </div>
      </ScrollArea>
    </div>
  );
}
